// Shared localStorage cache for the rider's Strava activities. A single source
// of truth for the cache key/version so callers (CreatePage, ChallengeAhaHero)
// cannot drift apart on the format. The /create page is the canonical writer;
// other surfaces can read for an instant value and write to keep it warm.

export const STRAVA_ACTIVITIES_CACHE_VERSION = 1;

export const getStravaActivitiesCacheKey = (userId) => (
  `mythicmaps:stravaActivities:${userId}:v${STRAVA_ACTIVITIES_CACHE_VERSION}`
);

export const readCachedStravaActivities = (userId) => {
  if (!userId || typeof window === 'undefined') {
    return null;
  }

  try {
    const storage = window.localStorage;
    if (!storage) return null;

    const raw = storage.getItem(getStravaActivitiesCacheKey(userId));
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (
      parsed?.version !== STRAVA_ACTIVITIES_CACHE_VERSION ||
      !Array.isArray(parsed.activities)
    ) {
      return null;
    }

    return {
      activities: parsed.activities,
      fetchedAt: typeof parsed.fetchedAt === 'number' ? parsed.fetchedAt : null
    };
  } catch (error) {
    console.warn('stravaActivitiesCache: failed to read cached Strava activities', error);
    return null;
  }
};

export const writeCachedStravaActivities = (userId, activities) => {
  if (!userId || typeof window === 'undefined' || !Array.isArray(activities)) {
    return null;
  }

  const fetchedAt = Date.now();
  try {
    const storage = window.localStorage;
    if (!storage) return null;

    storage.setItem(
      getStravaActivitiesCacheKey(userId),
      JSON.stringify({
        version: STRAVA_ACTIVITIES_CACHE_VERSION,
        fetchedAt,
        activities
      })
    );
    return fetchedAt;
  } catch (error) {
    console.warn('stravaActivitiesCache: failed to cache Strava activities', error);
    return null;
  }
};
